export default "__VITE_ASSET__DSqu7WcH__"